import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { ComponentsDesignTokens } from '@primeng/themes/types';
import { AccordionDesignTokens } from '@primeng/themes/types/accordion';
import { ButtonDesignTokens } from '@primeng/themes/types/button';
import { FieldsetDesignTokens } from '@primeng/themes/types/fieldset';
import { ToggleButtonDesignTokens } from '@primeng/themes/types/togglebutton';

export const FLTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6f4ee',
      100: '#c0e4d4',
      200: '#99d3ba',
      300: '#66bb9a',
      400: '#33a37a',
      500: '#00915a',
      600: '#007e4e',
      700: '#006b43',
      800: '#005837',
      900: '#00462c',
      950: '#002d1b',
    },
  },
  components: {
    accordion: {
      header: {
        activeColor: 'var(--p-primary-100)',

        activeBackground: 'var(--p-primary-500)',
        activeHoverBackground: 'var(--p-primary-600)',

        hoverBackground: 'var(--p-primary-200)',
        hoverColor: 'var(--p-primary-50)',

        background: 'var(--p-primary-200)',
        color: 'var(--p-primary-50)',
      },
      content: {
        background: 'var(--p-surface-50)',
        borderWidth: '1px',
        borderColor: 'var(--p-surface-100)',
      },
    } satisfies AccordionDesignTokens,

    fieldset: {
      legend: {
        background: 'transparent',
      },
    } satisfies FieldsetDesignTokens,

    togglebutton: {
      content: {
        checkedBackground: 'var(--p-primary-200)!important',
      },
    } satisfies ToggleButtonDesignTokens,
    button: {
      root: {
        badgeSize: '1.1rem',
      },
    } satisfies ButtonDesignTokens,
  } satisfies ComponentsDesignTokens,
});
